//model-meta generated file
import {DateTime,ModelMeta,uuid} from '../../lib/model-meta';
import {WhereTable,RestTypes as _RestTypes} from '../../lib/model-meta';

export class Client{
	public id:number;
	public name:string;
	public authToken:string|null=null;
	public enabled:boolean=true;
	public materialType:string="";
	public benchHeight:string="";
	public benchSeam:string="";
}

export namespace Client{
	export const meta=new ModelMeta<keyof Props>(
		"Client",
		[],
		[
			{
				name: "id",
				type: "serial",
				decorators: {},
				uniqueKey: true,
				notNull: true
			},{
				name: "name",
				type: "string",
				decorators: {
					uniqueKey: true
				},
				uniqueKey: true,
				notNull: true
			},{
				name: "authToken",
				type: "string",
				decorators: {
					uniqueKey: true
				},
				uniqueKey: true,
				default: null,
				optional: true
			},{
				name: "enabled",
				type: "boolean",
				decorators: {},
				default: true,
				optional: true,
				notNull: true
			},{
				name: "materialType",
				type: "string",
				decorators: {},
				default: "",
				optional: true,
				notNull: true
			},{
				name: "benchHeight",
				type: "string",
				decorators: {},
				default: "",
				optional: true,
				notNull: true
			},{
				name: "benchSeam",
				type: "string",
				decorators: {},
				default: "",
				optional: true,
				notNull: true
			}
		]
	);

	interface Props{
		id:number;
		name:string;
		authToken?:string|null;
		enabled?:boolean;
		materialType?:string;
		benchHeight?:string;
		benchSeam?:string;
	}


	meta.generateRest("client",[
		{
			name: "email",
			type: "string",
			decorators: {}
		},{
			name: "authToken",
			type: "string",
			decorators: {}
		}
	]);

	export interface ReadableProps{
		id:number;
		name:string;
		authToken?:string|null;
		enabled?:boolean;
		materialType?:string;
		benchHeight?:string;
		benchSeam?:string;
	}

	export interface ReadablePrimitiveProps{
		id:number;
		name:string;
		authToken?:string|null;
		enabled?:boolean;
		materialType?:string;
		benchHeight?:string;
		benchSeam?:string;
	}

	namespace body{

		interface WritableProps{
			name:string;
			authToken?:string|null;
			enabled?:boolean;
			materialType?:string;
			benchHeight?:string;
			benchSeam?:string;
		}

		export interface Auth{
			email?:string;
			authToken?:string;
		}

		export interface Get extends Auth{
			where:number;
			fields?:(keyof ReadableProps)[];
		}

		export interface Put extends Auth{
			where:number;
			fields:Partial<WritableProps>;
		}

		export interface Post extends Auth{
			fields:Partial<WritableProps>;
		}

		export interface Delete extends Auth{
			where:number;
		}

		export interface Count extends Auth{
			where?:WhereTable<keyof ReadablePrimitiveProps>;
		}

		export interface Search extends Auth{
			fields?:(keyof ReadablePrimitiveProps)[];
			where?:WhereTable<keyof ReadablePrimitiveProps>;
			range?:[number,number];
			sort?:Partial<Record<keyof ReadablePrimitiveProps,'+'|'-'>>;
		}
	}

	namespace _response{
		export type Get=Partial<ReadableProps>;
		export type Search=Partial<ReadablePrimitiveProps>[];
	}

	export interface RestTypes extends _RestTypes{
		body:{
			Auth:body.Auth;
			Get:body.Get;
			Put:body.Put;
			Post:body.Post;
			Delete:body.Delete;
			Count:body.Count;
			Search:body.Search;
		}

		response: {
			Get:_response.Get;
			Search:_response.Search;
		}
	}

}
